import outdatedBrowserRework  from "outdated-browser-rework";
import "outdated-browser-rework/dist/style.css"

outdatedBrowserRework({
    browserSupport: {
        Chrome: 86,
        Edge: 86,
        Safari: 12,
        "Mobile Safari": 12,
        Firefox: 73,
        Opera: 50,
        Vivaldi: 1,
        Yandex: 17,
        IE: false
    },
    requireChromeOnAndroid: false,
    isUnknownBrowserOK: true,
    messages: {
        en: {
            outOfDate: "Your browser is out of date!",
            unsupported: "Your browser is not supported!",
            update: {
                web: "Update your browser to view this website correctly. ",
                googlePlay: "Please install Chrome from Google Play",
                appStore: "Please update iOS from the Settings App"
            },
            // You can set the URL to null if you do not want a clickable link or provide
            // your own markup in the `update.web` message.
            url: "https://www.kienso.fr/update-browser/en?source=" + document.location.host,
            callToAction: "Update my browser now",
            close: "Close"
        },
        fr: {
            outOfDate: "Votre navigateur n'est plus à jour!",
            unsupported: "Votre navigateur n'est pas supporté!",
            update: {
                web: "Mettez à jour votre navigateur pour afficher correctement ce site Web. ",
                googlePlay: "Veuillez installer Chrome à partir de Google Play",
                appStore: "Veuillez mettre à jour iOS à partir de l'application Réglages"
            },
            // You can set the URL to null if you do not want a clickable link or provide
            // your own markup in the `update.web` message.
            url: "https://www.kienso.fr/update-browser/fr?source=" + document.location.host,
            callToAction: "Mettre à jour mon navigateur",
            close: "Fermer"
        }
    }
});
